<template>
    <div class="main">

        <c-panel>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Relatórios</label>
                    <el-select v-model="tipo">
                        <el-option :key="1" label="GERAL" :value="1"></el-option>
                        <el-option :key="2" label="ALUNOS COM DEFICIÊNCIA" :value="2"></el-option>
                        <el-option :key="3" label="ALUNOS COM ALERGIA" :value="3"></el-option>
                        <el-option :key="4" label="ALUNOS COM PATOLOGIA" :value="4"></el-option>
                        <el-option :key="5" label="ALUNOS EVADIDOS" :value="5"></el-option>
                        <el-option :key="6" label="ALUNOS PENDENTES" :value="6"></el-option>
                        <el-option :key="7" label="ALUNOS COM DEFASAGEM" :value="7"></el-option>
                        <el-option :key="8" label="ALUNOS PARA DISTRIBUIÇÃO DO KIT" :value="8"></el-option>
                        <el-option :key="9" label="ALUNOS QUILOMBOLA" :value="9"></el-option>
                        <el-option :key="10" label="ALUNOS PRESENTES" :value="10"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>

        <div v-if="tipo == 1" class="u-mt-10">
            <geral></geral>
        </div>

        <div v-if="tipo == 2" class="u-mt-10">
            <deficiencia></deficiencia>
        </div>

        <div v-if="tipo == 3" class="u-mt-10">
            <alergia></alergia>
        </div>

        <div v-if="tipo == 4" class="u-mt-10">
            <doenca></doenca>
        </div>

        <div v-if="tipo == 5" class="u-mt-10">
            <alunos-evadidos></alunos-evadidos>
        </div>

        <div v-if="tipo == 6" class="u-mt-10">
            <alunos-pendentes></alunos-pendentes>
        </div>       
        
        <div v-if="tipo == 7" class="u-mt-10">
            <alunos-defasagem></alunos-defasagem>
        </div>
        
        <div v-if="tipo == 8" class="u-mt-10">
            <alunos-distribuicao-kit></alunos-distribuicao-kit>
        </div>
        <div v-if="tipo == 9" class="u-mt-10">
            <quilombola></quilombola>
        </div>
        <div v-if="tipo == 10" class="u-mt-10">
            <alunos-presentes></alunos-presentes>
        </div>
    </div>
</template>
<script>

import geral from "./geral"
import deficiencia from "./deficiencia"
import alergia from "./alergia"
import doenca from "./doenca"
import alunosPendentes from "./alunos-pendentes"
import alunosDistribuicaoKit from "./alunos-distribuicao-kit"
import alunosDefasagem from "./defasagem"
import alunosEvadidos from "./alunos-evadidos.vue"
import quilombola from "../especial/quilombola"
import alunosPresentes from "./alunos-presentes"

export default {
    data: () => ({
        tipo: 1
    }),
    mounted () {

    },
    methods: {
        text(){


        }
    },
    components:{ geral, deficiencia, alergia, doenca, alunosPendentes, alunosDistribuicaoKit, alunosDefasagem, alunosEvadidos, quilombola, alunosPresentes }
}
</script>